module.exports = __webpack_public_path__ + "static/media/banner.869bb565.jpg";